import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3c525b9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-nav-section" }
const _hoisted_2 = { class: "container header-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bars" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "main-menu-wrapper" }
const _hoisted_6 = { class: "menu-title" }
const _hoisted_7 = {
  key: 0,
  class: "icon-menu"
}
const _hoisted_8 = { class: "search-header" }
const _hoisted_9 = { class: "header-icons" }

import { onMounted, ref, computed, watch } from 'vue'
import { useRouter } from 'vue-router'
import { HeartOutlined, UserOutlined, SearchOutlined, ShoppingCartOutlined } from '@ant-design/icons-vue'
import { MENU_HEADER_TOP1_COOKIE, COMPANY_DETAIL_COOKIE } from '@/const/ConstCookies'
import { V1_REDIS_GET_KEY } from "@/api/const/redis";
import { apiPost, apiGetNoParam, apiGet } from "@/api/index";
import commons from "@/utils/Common";
import MegaMenu from "@/components/Headers/default/menu/MegaMenu.vue"
import CartMenu from "@/views/client/cart/CartMenu.vue"
import store from '@/store';
interface Props {
  dataMenu: any[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderMenu',
  props: {
    dataMenu: { default: () => [] }
  },
  emits: ["openMenuMobile"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const router = useRouter()
const isSearch = ref(false)
const searchValue = ref('')

const cartCount = ref(0)
const showMegaMenu = ref(false)
const menuHeader: any = ref([]);
const megaMenu: any = ref([]);


const props = __props

onMounted(async () => {
    // await loadMenuHeaderTop();
    getCart()
});

const loadMenuHeaderTop = async () => {
    await apiGetNoParam(
        V1_REDIS_GET_KEY + "?key=menu-top-header"
    ).then((res) => {
        let response: any = res;
        let data = response.data.data
        commons.setLocalStorage(MENU_HEADER_TOP1_COOKIE, data)
        let menuTop = JSON.parse(commons.getLocalStorage(MENU_HEADER_TOP1_COOKIE) || 'null')
        menuHeader.value = menuTop;
    });

}
const getCart = () => {
    loadCart()
}
const showDrawer = () => {
    emits('openMenuMobile')
}

let hoverTimeout: any = null
const onMouseEnter = (item: any) => {
    if (hoverTimeout) clearTimeout(hoverTimeout)
    if (item.menuClass === 'megaMenu') {
        console.log('megaMenu', item)
        megaMenu.value = item.children
        showMegaMenu.value = true
    } else {
        showMegaMenu.value = false
    }
}

const onMouseLeave = (item: any) => {
    if (item.menuClass === 'megaMenu') {
        hoverTimeout = setTimeout(() => {
            showMegaMenu.value = false
        }, 150)
    }
}

const loadCart = () => {
    let dataList = commons.getLcCartObject();
    cartCount.value = dataList.orderList.length || 0
};

const isLoadCart = computed(() => {
    return store.getters.isLoadCart;
});
watch(isLoadCart, async (newValue, oldValue) => {
    await loadCart();
});

const handleMegaMenuEnter = () => {
    if (hoverTimeout) {
        clearTimeout(hoverTimeout)
    }
    showMegaMenu.value = true
}

const handleMegaMenuLeave = () => {
    hoverTimeout = setTimeout(() => {
        showMegaMenu.value = false
    }, 150)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_badge = _resolveComponent("a-badge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "nav-mobile",
        for: "menu-btn"
      }, [
        _createElementVNode("label", {
          class: "btn menu-btn",
          onClick: showDrawer
        }, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createVNode(_component_a_menu, {
          mode: "horizontal",
          class: "main-menu"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataMenu, (item) => {
              return (_openBlock(), _createBlock(_component_a_menu_item, {
                key: item.id,
                onMouseenter: ($event: any) => (onMouseEnter(item)),
                onMouseleave: ($event: any) => (onMouseLeave(item)),
                class: "menu-header"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, [
                    _createVNode(_component_router_link, {
                      to: item.linkTo,
                      class: "nav-link"
                    }, {
                      default: _withCtx(() => [
                        (item.icon != null && item.icon.length > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                              _createElementVNode("i", {
                                class: _normalizeClass(item.icon)
                              }, null, 2)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t(item.linkLabel)) + " " + _toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ]),
                _: 2
              }, 1032, ["onMouseenter", "onMouseleave"]))
            }), 128))
          ]),
          _: 1
        }, 512), [
          [_vShow, !isSearch.value]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_8, [
          _createVNode(_component_a_input_search, {
            size: "large",
            value: searchValue.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
            placeholder: "input search loading with enterButton",
            "enter-button": ""
          }, null, 8, ["value"])
        ], 512), [
          [_vShow, isSearch.value]
        ]),
        (showMegaMenu.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "mega-menu",
              onMouseenter: handleMegaMenuEnter,
              onMouseleave: handleMegaMenuLeave
            }, [
              _createVNode(MegaMenu, { megaMenu: megaMenu.value }, null, 8, ["megaMenu"])
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_unref(SearchOutlined), {
          class: "icon",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (isSearch.value = !isSearch.value))
        }),
        _createVNode(_component_a_badge, {
          count: cartCount.value,
          "number-style": { backgroundColor: '#b19663' },
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_dropdown, null, {
              overlay: _withCtx(() => [
                _createVNode(CartMenu)
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", null, [
                  _createVNode(_unref(ShoppingCartOutlined), { class: "icon" })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["count"])
      ])
    ])
  ]))
}
}

})